import { getSignedUrls } from "../services/images.service";
import { useQuery } from "@tanstack/react-query";
import { QueryKeys } from "./queryKeys";
import { hashKeys } from "../tools";

export const useSignedUrls = (fileNames: string[], size: "small" | "large") => {
  return useQuery({
    queryKey: [QueryKeys.SignedUrls, hashKeys(fileNames), size],
    queryFn: () => getSignedUrls(fileNames, size),
    gcTime: 1000 * 60 * 25, // 25 minutes — ensures cache is cleared before the 30-minute signed URL expiry
    staleTime: 1000 * 60 * 25, // 25 minutes — triggers a refetch with 5 minutes to spare before signed URLs expire
    enabled: !!fileNames.length,
  });
};
